import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import GalleryScreen from '../screens/gallery/GalleryScreen';
import GalleryFolderImagesScreen from '../screens/gallery/GalleryFolderImagesScreen';

const Stack = createNativeStackNavigator();

const GalleryNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="GalleryFolderList" component={GalleryScreen} />
      <Stack.Screen name="GalleryFolderImages" component={GalleryFolderImagesScreen} />
    </Stack.Navigator>
  );
};

export default GalleryNavigator;
